import {
  Card,
  Checkbox,
  Iconography,
  IconographySizes,
} from "@hid-galaxy-ui/galaxy-react";
import "./CustomCheckBox.scss";
import { GroupCheckbox } from "@hid-galaxy-ui/galaxy-react/components/Checkbox";
import { checkboxAlignment } from "@hid-galaxy-ui/galaxy-react/components/Checkbox/checkboxEnum";

interface CustomCheckBoxProps {
  fieldKey: string;
  fieldLabel: string;
  fieldValue: string[];
  options: string[];
  isRequired?: boolean;
  handleChange: (key: string, value: string[]) => void;
}

const CustomCheckBox: React.FC<CustomCheckBoxProps> = ({
  fieldKey,
  fieldLabel,
  fieldValue,
  options,
  isRequired = false,
  handleChange,
}) => {
  const onCheckboxClick = (
    e: React.ChangeEvent<HTMLInputElement>,
    eventResult: {
      checked: boolean;
      value: string;
    }
  ) => {
    let valueArray = [...fieldValue];
    if (eventResult.checked) {
      if (!valueArray.includes(eventResult.value)) {
        valueArray.push(eventResult.value);
        handleChange(fieldKey, valueArray);
      }
    } else {
      let newValueArray = valueArray.filter(
        (option) => !(option === eventResult.value)
      );
      handleChange(fieldKey, newValueArray);
    }
  };
  return (
    <div className="custom-checkbox-form-group">
      <GroupCheckbox
        label={fieldLabel}
        align={checkboxAlignment.vertical}
        isRequired={isRequired}
      >
        {options.map((option) => {
          const checked = fieldValue.includes(option);
          return (
            <Checkbox
              key={option}
              name={option}
              value={option}
              checked={checked}
              id={option}
              onChange={onCheckboxClick}
            ></Checkbox>
          );
        })}
      </GroupCheckbox>
    </div>
  );
};

export default CustomCheckBox;
